import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Select from "react-select";
import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  InputGroup,
  Checkbox,
  FormControl, Form
} from "react-bootstrap";
// import '../../assets/css/pages/add-edit-form.css'
import { getUserById, updateUser, addUser, getUsers, deleteUser } from '../../services/userService';
import { getCountry } from '../../services/countryService';
import { getLanguage } from '../../services/languageService';
import { getOrganization } from '../../services/organizationService';
import { getUserId, getUserType as getUserRole, getRolePermission } from "../../services/roleService";
import { getRole } from '../../services/roleTypeService';
import { BsArrowLeftShort } from "react-icons/bs";
import { ToastContainer, toast } from 'react-toastify';
import ToastLayout from '../../views/partials/Toastify';

export default function UserOrgAddEdit() {
  var user;
  const [language, setLanguage] = useState();
  const [country, setCountry] = useState();
  const [roleType, setRoleType] = useState();
  const [state, setState] = useState({
    id: '', bLabel: 'Add', FormLabel: 'Add'
  });
  const [activeState, setActiveState] = useState({
    active: "1"
  });
  const [privateState, setPrivateState] = useState({
    private: "1"
  });
  const [countryData, setCountryData] = useState({
    data: []
  });
  const [languageData, setLanguageData] = useState({
    language: []
  });
  const [roleData, setRoleData] = useState({
    role: []
  });
  const history = useHistory();
  const { id, organizationId } = useParams();
  let fetchUser = async (id) => {
    let privateValue;
    let activeValue;
    user = await getUserById(id);
    if (typeof (id) !== 'undefined') {
      setState({ ...user, bLabel: 'Update', FormLabel: 'Edit' });
      if(user.private==true){
        privateValue="1"
      }else{
        privateValue="0"
      }
      if(user.active==true){
        activeValue="1"
      }else{
        activeValue="0"
      }
      setPrivateState({
        private: privateValue
      });
      setActiveState({
        active: activeValue
      });
    }
  }
  useEffect(async () => {
    if (typeof (id) !== 'undefined') {
      await fetchUser(id);
    }
    reloadCountry();
    reloadLanguage();
    reloadRoleType();
  }, [])
  let backButton = () => {
    if (id == undefined) {
      history.push("/user-organization/" + organizationId);
    } else {
      history.push("/user-organization/" + state.organization_id);
    }
  }
  const handleCancel = () => {
    if (id == undefined) {
      history.push("/user-organization/" + organizationId);
    } else {
      history.push("/user-organization/" + state.organization_id);
    }
  }
  //display country name
  let reloadCountry = async () => {
    let record = await getCountry();
    setCountryData({ ...countryData, data: record });
    if (typeof (id) !== 'undefined') {
      setCountry(record.filter((pre) => {
        if (pre.id === user.country_id)
          return true;
      }))
    }
  }
  //display language name
  let reloadLanguage = async () => {
    let languageRecord = await getLanguage();
    setLanguageData({ ...languageData, language: languageRecord });
    if (typeof (id) !== 'undefined') {
      setLanguage(languageRecord.filter((pre) => {
        if (pre.id === user.language_id)
          return true;
      }))
    }
  }
  //display Roletype
  let reloadRoleType = async () => {
    let roleRecord = await getRole();
    var role_id;
    let chooseOption = roleRecord.filter((item) => {
      if (item.role_type === getUserRole()) {
        role_id = item.id;
      }
      return item.id >= role_id
    })
    setRoleData({ ...roleData, role: chooseOption });
    if (typeof (id) !== 'undefined') {
      setRoleType(roleRecord.filter((pre) => {
        if (pre.role_type === user.role_type)
          return true;
      }))
    }
  }
  //generate uuid
  function uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  const selectLanguage = (e) => {
    setState({ ...state, ["language_id"]: e.id });
    setLanguage(e);
  }
  let selectCountry = (e) => {
    setState({ ...state, ["country_id"]: e.id });
    setCountry(e);
  }
  let selectRoleType = (e) => {
    setState({ ...state, ["role_type"]: e.role_type });
    setRoleType(e);
  }
  let handleChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  }
  //Radio button
  let activeRadioChange = (e) => {
    setActiveState({
      active: e.target.value,
    });
  }
  let privateRadioChange = (e) => {
    setPrivateState({
      private: e.target.value
    });
  }
  let handleSubmit = async (e) => {
    e.preventDefault();
    // if (!state.username || !state.username.length) {
    //   return;
    // }

    const newItem = {
      username: null,
      // password: state.password,
      first_name: state.first_name,
      last_name: state.last_name,
      email: state.email,
      mobile_number_1: state.mobile_number_1,
      mobile_number_2: state.mobile_number_2,
      address: state.address,
      city: state.city,
      zip: state.zip,
      country_id: state.country_id,
      latitude: state.latitude,
      longitude: state.longitude,
      language_id: state.language_id,
      private: false,
      organization_id: organizationId,
      active: activeState.active,
      role_type: state.role_type
    };
    if (state.id !== '') { //update
      newItem.id = state.id;
      let updateId = newItem.id
      let response = await updateUser(newItem);
      if (response.result == 'fail') {
        toast.error(ToastLayout("Email or mobile number already exist!"))
      } else {
        history.push("/user-organization/" + state.organization_id);
      }
    } else { //add
      if (newItem.country_id) {
        if (newItem.language_id) {
          if (newItem.role_type) {
            let response = await addUser(newItem);
            if (response.result == 'fail') {
              toast.error(ToastLayout("Email or mobile number already exist!"))
            } else {
              history.goBack();
            }
          } else {
            toast.error(ToastLayout("Please select role type"))
          }
        } else {
          toast.error(ToastLayout("Please select language"))
        }
      } else {
        toast.error(ToastLayout("Please select country"))
      }
    }
  }
  let doDelete = async (user_id) => {
    await deleteUser( user_id )
    history.goBack();
  }
  let getDeleteButton = (user_id) => {
    if (getRolePermission('users', getUserRole()) > 2) {
      if (typeof (user_id) !== 'undefined') {
        return (
        <button onClick={(e)=>{e.preventDefault();doDelete(user_id)}} className="cancle-button-style">
          Delete
        </button>
        )
      };
    }
  }
  return (
    <div>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="striped-table-with-hover">
              <Card.Header>
                <div className='display-back-button'>
                  <div><button className="back" data-toggle="tooltip" title="click to go back" onClick={() => { backButton() }} ><BsArrowLeftShort /></button></div>
                  <div className="form-header-container form-header" style={{ marginTop: "05px" }}>
                    <center>{state.FormLabel} User</center>
                  </div>
                </div>
              </Card.Header>

              <Card.Body className="px-0">

                <Col lg="9">
                  <Form >
                    {/* <Form.Group as={Row} className="mb-3" >
                      <Col sm="3">
                        <div className="add-responsive">Username :</div>
                      </Col>
                      <Col sm="9">
                        <input
                          name="username"
                          placeholder="User Name"
                          onChange={handleChange}
                          value={state.username}
                          className="input-style-responsive"
                        />
                      </Col>
                    </Form.Group> */}

                    {/* <Form.Group as={Row} className="mb-3" >
                      <Col sm="3">
                        <div className="add-responsive">Password :</div>
                      </Col>
                      <Col sm="9">
                        <input
                          type="password"
                          name="password"
                          placeholder="Password"
                          onChange={handleChange}
                          value={state.password}
                          className="input-style-responsive"
                        />
                      </Col>
                    </Form.Group> */}

                    <Form.Group as={Row} className="mb-3" >
                      <Col sm="3">
                        <div className="add-responsive">First Name :</div>
                      </Col>
                      <Col sm="9">
                        <input
                          name="first_name"
                          placeholder="First Name"
                          onChange={handleChange}
                          value={state.first_name}
                          className="input-style-responsive"
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" >
                      <Col sm="3">
                        <div className="add-responsive">Last Name :</div>
                      </Col>
                      <Col sm="9">
                        <input
                          name="last_name"
                          placeholder="Last Name"
                          onChange={handleChange}
                          value={state.last_name}
                          className="input-style-responsive"
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" >
                      <Col sm="3">
                        <div className="add-responsive">Email :</div>
                      </Col>
                      <Col sm="9">
                        <input
                          name="email"
                          placeholder="Email"
                          onChange={handleChange}
                          value={state.email}
                          className="input-style-responsive"
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" >
                      <Col sm="3">
                        <div className="add-responsive">Primary Mobile No :</div>
                      </Col>
                      <Col sm="9">
                        <input
                          name="mobile_number_1"
                          placeholder="Primary Mobile Number e.g: +82738183652"
                          onChange={handleChange}
                          value={state.mobile_number_1}
                          className="input-style-responsive"
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" >
                      <Col sm="3">
                        <div className="add-responsive">Secondary Mobile No :</div>
                      </Col>
                      <Col sm="9">
                        <input
                          name="mobile_number_2"
                          placeholder="Secondary Mobile Number e.g: +82738183652"
                          onChange={handleChange}
                          value={state.mobile_number_2}
                          className="input-style-responsive"
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" >
                      <Col sm="3">
                        <div className="add-responsive">Address :</div>
                      </Col>
                      <Col sm="9">
                        <input
                          name="address"
                          placeholder="Address"
                          onChange={handleChange}
                          value={state.address}
                          className="input-style-responsive"
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" >
                      <Col sm="3">
                        <div className="add-responsive">City :</div>
                      </Col>
                      <Col sm="9">
                        <input
                          name="city"
                          placeholder="City"
                          onChange={handleChange}
                          value={state.city}
                          className="input-style-responsive"
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" >
                      <Col sm="3">
                        <div className="add-responsive">Zip Code :</div>
                      </Col>
                      <Col sm="9">
                        <input
                          name="zip"
                          placeholder="Zip code"
                          onChange={handleChange}
                          value={state.zip}
                          className="input-style-responsive"
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" >
                      <Col sm="3">
                        <div className="add-responsive">Country :</div>
                      </Col>
                      <Col sm="9">
                        <Select
                          className="dropDown-style"
                          value={country}
                          options={countryData.data}
                          getOptionLabel={e => e.country}
                          getOptionValue={e => e.id}
                          onChange={(e) => selectCountry(e)}
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" >
                      <Col sm="3">
                        <div className="add-responsive">Latitude :</div>
                      </Col>
                      <Col sm="9">
                        <input
                          name="latitude"
                          placeholder="Latitude e.g: 72.8763"
                          onChange={handleChange}
                          value={state.latitude}
                          className="input-style-responsive"
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" >
                      <Col sm="3">
                        <div className="add-responsive">Longitude :</div>
                      </Col>
                      <Col sm="9">
                        <input
                          name="longitude"
                          placeholder="Longitude e.g: 72.8763"
                          onChange={handleChange}
                          value={state.longitude}
                          className="input-style-responsive"
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" >
                      <Col sm="3">
                        <div className="add-responsive">Language :</div>
                      </Col>
                      <Col sm="9">
                        <Select
                          className="dropDown-style"
                          value={language}
                          options={languageData.language}
                          getOptionLabel={e => e.language_name}
                          getOptionValue={e => e.id}
                          onChange={(e) => selectLanguage(e)}
                        />
                      </Col>
                    </Form.Group>

                    {/* <Form.Group as={Row} className="mb-3" >
                      <Col sm="3">
                        <div className="add-responsive">Private :</div>
                      </Col>
                      <Col sm="9">
                        <div className="input-style-responsive">
                          <input
                            type="radio"
                            name="private"
                            onChange={privateRadioChange}
                            value="1"
                            className="radiobutton"
                            checked={privateState.private === "1"}
                          />
                          &nbsp;&nbsp;Yes&nbsp;&nbsp;&nbsp;&nbsp;
                          <input
                            type="radio"
                            name="private"
                            onChange={privateRadioChange}
                            value="0"
                            className="radiobutton"
                            checked={privateState.private === "0"}
                          />&nbsp;&nbsp;No
                        </div>
                      </Col>
                    </Form.Group> */}

                    <Form.Group as={Row} className="mb-3" >
                      <Col sm="3">
                        <div className="add-responsive">Active :</div>
                      </Col>
                      <Col sm="9">
                        <div className="input-style-responsive" >
                          <input
                            type="radio"
                            name="active"
                            onChange={activeRadioChange}
                            value="1"
                            className="radiobutton"
                            checked={activeState.active === "1"}
                          />
                          &nbsp;&nbsp;Yes&nbsp;&nbsp;&nbsp;&nbsp;
                          <input
                            type="radio"
                            name="active"
                            onChange={activeRadioChange}
                            value="0"
                            className="radiobutton"
                            checked={activeState.active === "0"}
                          />&nbsp;&nbsp;No
                        </div>
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" >
                      <Col sm="3">
                        <div className="add-responsive">Role Type :</div>
                      </Col>
                      <Col sm="9">
                        <Select
                          className="dropDown-style"
                          value={roleType}
                          options={roleData.role}
                          getOptionLabel={e => e.role_type}
                          getOptionValue={e => e.role_type}
                          onChange={(e) => selectRoleType(e)}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3" >
                      <Col>
                        <div className="button-container-responsive">
                        <ToastContainer />
                          <button onClick={handleSubmit} className="add-button-style">
                            {state.bLabel}
                          </button>
                          {getDeleteButton(id)}
                          <button onClick={handleCancel} className="cancle-button-style">
                            Cancel
                          </button>
                        </div>
                      </Col>

                    </Form.Group>
                  </Form>
                </Col>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
        </Row>
      </Container>
    </div>
  );
}